import * as React from 'react';

function SvgIconAlignCenter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6h16v9H4V6zM2 4h20v13H2V4zm18 17H4v-2h16v2z"
        fill="currentColor"
      />
    </svg>
  );
}

export const IconAlignCenter = React.memo(SvgIconAlignCenter);
